import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import { boot, isBootFailed } from './utils/tenantBoot';

boot().then(() => {
  const root = ReactDOM.createRoot(document.getElementById('root'));

  if (isBootFailed()) {
    root.render(
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh', fontFamily: 'system-ui', textAlign: 'center', padding: 24 }}>
        <div>
          <h1 style={{ fontSize: 24, marginBottom: 8 }}>Service Unavailable</h1>
          <p style={{ color: '#666' }}>This site is not configured or temporarily unavailable.</p>
        </div>
      </div>
    );
    return;
  }

  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
});
